import { APIModel } from '@/src/models/api-model';

export class TemplateCategory extends APIModel {
  id!: string;
  category_name!: string;

  static fieldsToMap = {
    direct: [
      'id',
      'category_name'
    ]
  }

  static buildFromAPI(record: any): TemplateCategory {
    const row = new TemplateCategory();
    record = record || {};

    this.mapFieldsDirectly<TemplateCategory>(TemplateCategory.fieldsToMap.direct, record, row);

    return row
  }
}